<div class="file-error-popup">
  <div class="file-error-popup__modal">
    <div class="file-error-popup__header">
      <h1 class="file-error-popup__title">
        {{ data.titleKey || 'inventory.uploadComponent.error.exportFailedTitle' | translate }}
      </h1>
      <button type="button" class="file-error-popup__cross-btn" (click)="close()">
        <app-icon class="file-error-popup__cross-icon" [icon]="IconName.CROSS" />
      </button>
    </div>

    <app-icon class="file-error-popup__fail-icon" [icon]="IconName.FAIL" />

    <div class="file-error-popup__text">
      <h2 class="file-error-popup__text-subtitle">
        {{ data.subtitleKey || 'inventory.uploadComponent.error.exportFailedSubtitle' | translate }}
      </h2>
      <p class="file-error-popup__text-message">{{ data.message || '' | translate }}</p>
    </div>

    <div class="file-error-popup__actions">
      <button type="button" class="file-error-popup__close-btn" (click)="close()">
        {{ 'inventory.uploadComponent.close' | translate }}
      </button>
      <button type="button" class="file-error-popup__action-btn" (click)="action()">
        {{
          data.type === FileErrorDialogType.Export
            ? ('inventory.uploadComponent.tryAgain' | translate)
            : ('inventory.uploadComponent.choose' | translate)
        }}
      </button>
    </div>
  </div>
</div>
